
export class ObjectUtility {

    /**
     * Case-insensitive retrieval of object properties
     * @param object object to parse
     * @param key property to return
     * @returns property if found
     */
    static getPropertyCaseInsensitive(object: any, key: string) {
        const asLowercase = key.toLowerCase();
        const property = Object.keys(object)
            .find(k => k.toLowerCase() === asLowercase);

        if (property) {
            return object[property];
        }
    }

    /**
     * Deep compare two arrays of the same type to determine if they have the same contents.
     */
    static sequenceEquals<T>(arr1: T[], arr2: T[]) {
        return _(arr1).differenceWith(arr2, _.isEqual).isEmpty();
    }
}
